import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Play, Pause, Volume2, VolumeX } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const VIDEO_URL = 'https://cdn.magicpatterns.com/uploads/mhsznEvARLYJr9fPBwN5Zp/Comprimid%202%20(1)%20(1).mp4';
export function DroneVideo() {
  const {
    t
  } = useLanguage();
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };
  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = !video.muted;
    setIsMuted(video.muted);
  };
  return <section id="video" className="py-24 bg-primary-dark" data-id="element-137" data-mp="3f0bj7mfz6bzm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138" data-mp="3eys3bwy8e2yd">
        <div className="max-w-2xl mb-12" data-id="element-139" data-mp="3iaqbicwo84l8">
          <span className="text-accent font-medium tracking-wider uppercase text-sm mb-3 block" data-id="element-140" data-mp="3idm9u2cfkva7">
            {t('Video', 'Video')}
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-4" data-id="element-141" data-mp="38kwzxbwj3pgz">
            {t('Cabañas Clarita desde el aire', 'Cabañas Clarita from above')}
          </h2>
          <p className="text-white/70 text-lg font-light" data-id="element-142" data-mp="2zl0hvt4n9ouw">
            {t('Un recorrido con dron por el predio y su entorno en Dina Huapi.', 'A drone tour of the property and its surroundings in Dina Huapi.')}
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.45,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative rounded-2xl overflow-hidden shadow-2xl bg-black" data-id="element-143" data-mp="2poxgiphm9u90">
          <video ref={videoRef} src={VIDEO_URL} className="w-full aspect-video object-cover" autoPlay muted loop playsInline aria-label={t('Video aéreo de Cabañas Clarita y su entorno', 'Aerial video of Cabañas Clarita and its surroundings')} data-id="element-144" data-mp="2dd4ty0ec52fo" />

          <div className="absolute bottom-4 right-4 flex gap-2" data-id="element-145" data-mp="2w3cqu0rfywnf">
            <button type="button" onClick={togglePlay} aria-label={isPlaying ? t('Pausar video', 'Pause video') : t('Reproducir video', 'Play video')} className="w-11 h-11 rounded-full bg-white/90 text-primary flex items-center justify-center hover:bg-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-146" data-mp="2w45peeg8yfuh">
              {isPlaying ? <Pause className="w-5 h-5" data-id="element-147" data-mp="1gndox78f3wvm" /> : <Play className="w-5 h-5" data-id="element-148" data-mp="185bs63h366ta" />}
            </button>
            <button type="button" onClick={toggleMute} aria-label={isMuted ? t('Activar sonido', 'Unmute') : t('Silenciar', 'Mute')} className="w-11 h-11 rounded-full bg-white/90 text-primary flex items-center justify-center hover:bg-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-149" data-mp="187fzywi3vpyu">
              {isMuted ? <VolumeX className="w-5 h-5" data-id="element-150" data-mp="khbxisgnlw9f" /> : <Volume2 className="w-5 h-5" data-id="element-151" data-mp="z5f8kg9jzy53" />}
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}